import { render, staticRenderFns } from "./EmailFormModal.vue?vue&type=template&id=715e627e&scoped=true&"
import script from "./EmailFormModal.vue?vue&type=script&lang=js&"
export * from "./EmailFormModal.vue?vue&type=script&lang=js&"
import style0 from "./EmailFormModal.vue?vue&type=style&index=0&id=715e627e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715e627e",
  null
  
)

export default component.exports